import React, { useEffect, useState } from 'react';
import { Page, Document, Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import logo from '../../../assets/images/logop7.jpg';
import DossieTitle from './DossieTitle';

import apiActivity from '@iso/services/repository/activity';
import apiAccountCustumer from '@iso/services/repository/accountCustumer';
import apiFiles from '@iso/services/repository/files';

import BlockOccurrence from './BlockOccurrence';
// import DossieItemsTable from './DossieItemsTable';

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft:60,
        paddingRight:60,
        lineHeight: 1.5,
        flexDirection: 'column',
    }, 
    logo: {
        width: 50,
        height: 50,
        marginLeft: 'auto',
        marginRight: 'auto'
    }
});
  
const Dossie = ({data}) => {
    // console.log(data)
    const [dossieData, setDossieData] = useState(null);
    const [ iconAccount, setIconAccount ] = useState([]);
    useEffect(() => {
        apiActivity
            .getActivityByCliente(data.client._id)
            .then(inv => {
                setDossieData(inv.data);
            })
            .catch(error => {
                console.error("Error fetching dossie data:", error);
            });
        apiAccountCustumer
            .getAccountCustumer()
            .then((response) => {
              if(response.data._id){
                if(response.data.icon){
                  renderImages(response.data.icon)
                }
                } else {
                    console.log(response.data);
                }
            })
            .catch((err) => {
              console.error( err);
            });
    }, [data.client._id]);
      
    function renderImages(images) {
        // console.log(images)
        images.forEach(imag => {
        viwerAnexo('images', imag, 'add_images')
        });
    }
      
    const viwerAnexo = (type, anx) => {
        try {
          apiFiles
            .getAnexos(type, anx._id)
            .then( response => {
                const blob = new Blob([response.data], { type: response.headers.get('content-type')}); 
                setIconAccount(
                    <Image style={styles.logo}  src={URL.createObjectURL(blob)}/>
                );
              })
        } catch (error) {
            console.log("arquivo não encontrado")
        }
    }

    if (!dossieData) {
        return null;
    }
    
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {iconAccount}
                <DossieTitle title={dossieData.client} />
                {
                    dossieData.allActivity.map(atv =>{
                        // if(atv.productsAndServices && atv.productsAndServices.length > 0){
                        //     return <DossieItemsTable data={atv.productsAndServices} />
                        // }
                        if(atv.occurrences && atv.occurrences.length > 0){
                            return <BlockOccurrence data={atv.occurrences} />
                        }
                    })
                }
            </Page>
        </Document>
    )
};
  
export default Dossie